import _ from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { RadioButtonGroup } from 'common-components'
import { selectProductLifeProtectPlus } from 'quick-quote/product-life-protect-plus/actions'
import { getSelectedProductLifeProtectPlus } from 'quick-quote/product-life-protect-plus/selectors'
import VALUES from 'core/data-model/constants/values'

export const LifeProtectPlusProductSelection = ({
  getSelectedProductLifeProtectPlus,
  selectProductLifeProtectPlus,
}) => {
  const productLifeProtectPlus = [
    {
      text: '9 ปี',
      value: VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_9_HIGHER,
    },
    {
      text: '19 ปี',
      value: VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_19_HIGHER,
    },
    {
      text: 'ถึงอายุ 99 ปี',
      value: VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_99_HIGHER,
    },
  ]

  return (
    <div className="form-group">
      <div className="form-group-title">
        <span className="form-group-title-text">ระยะเวลาการชำระเบี้ยประกัน</span>
      </div>
      <RadioButtonGroup
        keyToGetValue="value"
        className="model-factor"
        onChange={selectProductLifeProtectPlus}
        value={getSelectedProductLifeProtectPlus}
        options={productLifeProtectPlus}
      />
    </div>
  )
}

const mapStateToProps = (state) => ({
  getSelectedProductLifeProtectPlus: getSelectedProductLifeProtectPlus(state),
})

const mapDispatchToProps = (dispatch) => ({
  selectProductLifeProtectPlus: bindActionCreators(selectProductLifeProtectPlus, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(LifeProtectPlusProductSelection)
